export default "__VITE_ASSET__CHyHv9hI__"